import { render, staticRenderFns } from "./permittings.vue?vue&type=template&id=447fb570&scoped=true"
import script from "./permittings.vue?vue&type=script&lang=js"
export * from "./permittings.vue?vue&type=script&lang=js"
import style0 from "./permittings.vue?vue&type=style&index=0&id=447fb570&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447fb570",
  null
  
)

export default component.exports